export default __webpack_public_path__ + "024f7be78a68f812912cccb75a5f5b8a.png";